module.exports = __webpack_public_path__ + "img/inexact_loction_marker.0c2c6afbb36f12ecb6abf4ce4c8dfa41.png";